import * as React from "react";

const SvgIcnStraightFace = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
        <g clipPath="url(#clip0_3756_154305)">
            <path
                d="M5.14062 10.8594H10.8549"
                stroke="#606B85"
                strokeWidth="1.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.99888 15.4294C12.1016 15.4294 15.4275 12.1036 15.4275 8.00084C15.4275 3.89815 12.1016 0.572266 7.99888 0.572266C3.8962 0.572266 0.570312 3.89815 0.570312 8.00084C0.570312 12.1036 3.8962 15.4294 7.99888 15.4294Z"
                stroke="#606B85"
                strokeWidth="1.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.42634 6.28627C5.26854 6.28627 5.14062 6.15835 5.14062 6.00056C5.14062 5.84276 5.26854 5.71484 5.42634 5.71484"
                stroke="#606B85"
                strokeWidth="1.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.42578 6.28627C5.58358 6.28627 5.7115 6.15835 5.7115 6.00056C5.7115 5.84276 5.58358 5.71484 5.42578 5.71484"
                stroke="#606B85"
                strokeWidth="1.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5709 6.28627C10.4131 6.28627 10.2852 6.15835 10.2852 6.00056C10.2852 5.84276 10.4131 5.71484 10.5709 5.71484"
                stroke="#606B85"
                strokeWidth="1.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5703 6.28627C10.7281 6.28627 10.856 6.15835 10.856 6.00056C10.856 5.84276 10.7281 5.71484 10.5703 5.71484"
                stroke="#606B85"
                strokeWidth="1.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3756_154305">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default SvgIcnStraightFace;
